import type { PolicyDocument } from '../../types/policy';
import { company as c } from '../company';
import { changesSection } from './changes';

export const contactInformation: PolicyDocument = {
  title: 'Contact Information',
  lead: `How to reach ${c.brand} for orders, support, warranty claims, privacy requests and legal notices.`,
  sections: [
    {
      id: 'seller',
      heading: 'Seller',
      blocks: [
        {
          list: [
            `Trade name: ${c.brand}`,
            `Website: ${c.website}`,
            `Customer support: ${c.supportEmail}`,
            `Privacy requests: ${c.privacyEmail}`,
            ...(c.mailingAddress ? [`Mailing address: ${c.mailingAddress}`] : []),
          ],
        },
      ],
    },
    {
      id: 'support',
      heading: 'Customer support',
      blocks: [
        `Email ${c.supportEmail} or use the form on our Contact & Support page. Please include your order number so we can help you faster. We respond to most messages within 1 business day, Monday through Friday, excluding U.S. federal holidays.`,
        'Customer support is provided by email and web form only. We do not accept orders, claims, returns or legal notices by phone, text message or social media, and messages sent through those channels are not considered received.',
      ],
    },
    {
      id: 'orders',
      heading: 'Orders and tracking',
      blocks: [
        'Order confirmations and USPS tracking numbers are sent to the email address entered at checkout. You can track a shipment at any time on our Order Tracking page.',
      ],
    },
    {
      id: 'warranty',
      heading: 'Warranty claims and returns',
      blocks: [
        'Warranty claims must be submitted through our Warranty Claim page. Returns must be requested by email to receive a Return Authorization (RA) number. Do not mail products to us without an RA number and the return address we provide — unauthorized shipments will not be accepted.',
      ],
    },
    {
      id: 'privacy',
      heading: 'Privacy requests',
      blocks: [
        `To access, correct or delete your personal information, or to opt out of targeted advertising, email ${c.privacyEmail} with the subject "Privacy Request". We may need to verify your identity before completing a request.`,
      ],
    },
    {
      id: 'legal',
      heading: 'Legal notices',
      blocks: [
        `Formal legal notices, including notices of dispute required by our Terms of Service, must be sent in writing to ${c.supportEmail} with the subject "Legal Notice"${c.mailingAddress ? `, or by mail to ${c.mailingAddress}` : ''}. See our Legal Notice page for details.`,
      ],
    },
    changesSection('Contact Information'),
  ],
};
